<template>
    <el-dialog :title="title" :visible.sync="dialogTableVisible">
        <el-table :data="list" v-loading="loading">
            <el-table-column property="id" label="订单ID"></el-table-column>
            <el-table-column property="customer_name" label="客户名称"></el-table-column>
            <el-table-column property="user_name" label="业务员">
                <template slot-scope="scope">
                    <div v-for="(user, index) in scope.row.user" :key="index" v-show="user.is_cooperator == 0">
                        {{user.name}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column property="branch_name" label="所属部门">
                <template slot-scope="scope">
                    <div v-for="(user, index) in scope.row.user" :key="index" v-show="user.is_cooperator == 0">
                        {{user.branch_name}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作"  fixed="right">
                <template slot-scope="scope">
                    <el-button @click="handleView(scope.row)" type="text"  size="small">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
    </el-dialog>
</template>
<script>
    import ClueCount from "~/services/ClueCount";
    import MyPagination from "~/widgets/MyPagination.vue";
    export default {
        props:{
            params:{
                type: Object,
                required: true,
            },
            title:{
                type: String,
                required: false,
                default: '订单列表'
            },
        },
        components: {
            MyPagination
        },
        data(){
            return {
                list:[],
                loading: false,
                dialogTableVisible: true,
                linkPage: null,
            }
        },
        created() {
            this.getList();
        },
        methods: {
            //获取列表
            getList() {
                // loading 动画
                this.loading = true;
                ClueCount.getList(this.params, 'bind-order-table')
                .then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                    }
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    console.error(err);
                    this.loading = false;
                });
            },

            handleView(row) {
                let routeData = this.$router.resolve({
                    path: "/order/view",
                    query: { id: row.id },
                });
                window.open(routeData.href, '_blank');
            },

            handleSizeChange(newSize) {
                // 处理每页条目数变化事件
                let params = this.params;
                params['perPage'] = newSize;
                this.getList(params);
            },

            handleCurrentChange(newPage) {
                let params = this.params;
                // 处理当前页码变化事件
                params['page'] = newPage;
                this.getList(params);
            },
            
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/clue/dialog/orderListDialog.vue